:host {
  width: 100%;
  height: 100%;
  position: relative;
}

.hidden {
  visibility: hidden;
  pointer-events: none;
}

.column {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
}

